
import { call, delay, put } from 'redux-saga/effects'

import {
    ERROR_CLEAR_ACTION_TYPE,
    ERROR_CREATE_ACTION_TYPE,
    ERROR_OPERATION_START_ACTION_TYPE,
    ERROR_OPERATION_SUCCESS_ACTION_TYPE,
    ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE
} from './operationStatus';

export function createActionTypes(baseType, title) {
    return {
        DEFAULT: baseType,
        LOADING: `${baseType}_LOADING`,
        SUCCESS: `${baseType}_SUCCESS`,
        FAILED:  `${baseType}_FAILED`,
        title: title || baseType
    };
}

export function* clearActionType() {
    yield put({type: ERROR_CLEAR_ACTION_TYPE});
}

export function* clearOperationSuccess() {
    yield delay(3000);
    yield put({type: ERROR_OPERATION_SUCCESS_ACTION_TYPE, operation: null});
}

export function* clearOperationNotSuccess() {
    yield delay(10000);
    yield put({type: ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE, operation: null});
}

export function redirect(url, options) {
    if (options && options.history) {
        options.history.push(url);
    } else {
        console.warn(`object 'history' does not exist`);
    }
}

export function* setOperationStart(actionType) {
    yield put({type: ERROR_OPERATION_START_ACTION_TYPE, operation: actionType.title});
}

export function* setOperationNotSuccess(title, messages) {
    yield put({type: ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE, operation: {title, messages}});
}

export function* checkOperationResult(result, actionType) {
    if (result && result.success) {
        yield put({type: ERROR_OPERATION_SUCCESS_ACTION_TYPE, operation: actionType.title});
        yield call(clearOperationSuccess);
    }
    if (result && result.messages && (result.messages.length > 0)) {
        yield call(setOperationNotSuccess, actionType.title, result.messages);
        yield call(clearOperationNotSuccess);
    }
}

export function* setOperationError(error, actionType) {
    // ToDo: use loglevel
    console.error(error);
    yield put({type: actionType.FAILED, error});
    yield put({type: ERROR_CREATE_ACTION_TYPE, error});
}